import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PreProcessSettings } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})

export class PreProcessSettingsService extends BaseApiService<PreProcessSettings> {
  get cacheKey(): StorageKey {
    return StorageKey.preProcessSettingsServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.omniaCoreApiUrl}/v1/preProcessSettings`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected unparse(obj) {
    return PreProcessSettings.unparse(obj);
  }

  protected parse(obj) {
    return PreProcessSettings.parse(obj);
  }
}
